import { defineComponent, h, inject } from 'vue';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { ImageAsset } from '@/ui/components/asset/ImageAsset';
import { ImageAssetPdf } from '@/ui/components/asset/ImageAssetPdf';
import { LegacyPhoto } from '@/ui/components/inspectionReport/legacyTypes';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { isLowQualityImagesFromReportPageKey } from '@/ui/injectionKeys';
import { isPdf } from '@/ui/helpers/systemHelper';

export const Annotation = defineComponent<ItemProps>({
  name: 'Annotation',
  props: ['item'],
  setup(props) {
    return function render() {
      const isLowQualityImages = inject(isLowQualityImagesFromReportPageKey, false);
      let response;

      if (props.item.responded && props.item.response) {
        // params are from checklist builder question addition - we need to keep this image binary reference for pdf
        (props.item.response as LegacyPhoto).image = props.item.params.image;
        (props.item.response as LegacyPhoto).image_id = props.item.params.image_id;
        response = h('div', { class: 'flex' }, [
          h('span', { class: 'mr-1' }, [`${props.item.index}.`]),
          props.item.params.image_id
            ? h(ImageAsset, {
              class: 'mr-3 inline-block inspection-report__image-drawing-thumbnail',
              props: {
                photo: {
                  ...(props.item.response as LegacyPhoto),
                  image_id: props.item.params.image_id,
                },
                isLowQualityImages: isPdf && isLowQualityImages,
              },
            })
            : h(ImageAssetPdf, {
              class: 'mr-3 inline-block inspection-report__image-drawing-thumbnail',
              props: {
                photo: {
                  ...(props.item.response as LegacyPhoto),
                  image: props.item.params.image,
                },
              },
            }),
        ]);
      } else {
        response = null;
      }

      return h('div', {
        class: 'avoid-page-break',
      }, [
        props.item.responded ? response : h('span', useInspectionReport().getNotRespondedAnswer()),
      ]);
    };
  },
});
